<div class="row">
  <div class="col-12">
    <div class="card card-body">
      <div class="header">
        <h4 class="card-title mb-0">
          <span class="lstick"></span>Location Listing
        </h4>

        <div class="header-right">
          <div class="form-group mb-0" style="max-width: 200px; width: 100%">
            <input
              type="text"
              id="searchFilter"
              class="form-control"
              [(ngModel)]="searchFilter"
              placeholder="Search"
              (input)="onSearchFilterInput($event)"
            />
          </div>
          <a
            href="javascript: void(0);"
            class="btn btn-primary"
            placement="top"
            (click)="openModal(editModal, {}, 'Add Location')"
            ngbTooltip="Add Location"
          >
            + Add Location
          </a>
        </div>
      </div>

      <div class="table-responsive" *ngIf="!loading">
        <table class="table table-striped border mt-4">
          <thead class="table-light">
            <tr>
              <th scope="col">Title</th>
              <th scope="col">Address</th>
              <th scope="col">Created At</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let location of LocationDetails; let i = index">
              <td>
                <p placement="top" [ngbTooltip]="location.title">
                  {{
                    location.title
                      ? location?.title?.length > 30
                        ? (location.title | slice : 0 : 30) + "..."
                        : location.title
                      : "-"
                  }}
                </p>
              </td>
              <td>
                <p placement="top" [ngbTooltip]="location.address">
                  {{
                    location?.address?.length > 50
                      ? (location.address | slice : 0 : 50) + "..."
                      : location.address
                  }}
                </p>
              </td>
              <td>{{ location.created_at | date : "medium" }}</td>
              <td>
                <button
                  class="btn btn-sm btn-primary mr-1"
                  (click)="editLocation(location._id)"
                  ngbTooltip="Edit Location"
                >
                  <i class="fa fa-edit"></i>
                </button>
                <button
                  class="btn btn-sm btn-danger ms-1"
                  (click)="openDeleteModal(deleteModal, location._id)"
                  ngbTooltip="Delete"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </td>
            </tr>

            <tr *ngIf="LocationDetails?.length === 0 && !loading">
              <td colspan="8" class="text-center text-muted">
                No location records found.
              </td>
            </tr>
          </tbody>
        </table>

        <div
          class="d-flex justify-content-center mt-5"
          *ngIf="LocationDetails?.length != 0"
        >
          <ngb-pagination
            [(page)]="page"
            [pageSize]="pageSize"
            [collectionSize]="totalCount"
            [maxSize]="7"
            [rotate]="true"
            [ellipses]="false"
            [boundaryLinks]="true"
            (pageChange)="loadPage($event)"
          ></ngb-pagination>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #editModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="editProductLabel">{{ modeltitle }}</h5>
    <button
      type="button"
      class="close"
      (click)="closeBtnClick()"
      aria-label="Close"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <form (ngSubmit)="onSubmit()" #storeForm="ngForm">
    <div class="modal-body" style="max-height: 70vh; overflow-y: auto">
      <div class="form-group mb-4">
        <label for="title">Title: <span class="text-danger">*</span></label>
        <input
          type="text"
          class="form-control"
          id="title"
          [(ngModel)]="detail.title"
          name="title"
          required
          placeholder="Enter location title"
        />
        <div *ngIf="formSubmitted && !detail.title" class="text-danger">
          Title is required
        </div>
      </div>

      <div class="form-group mb-4">
        <label for="description">Description:</label>
        <quill-editor
          id="description"
          [(ngModel)]="detail.description"
          name="description"
          [modules]="quillConfig"
          placeholder="Enter location description"
        ></quill-editor>
        <div *ngIf="formSubmitted && !detail.description" class="text-danger">
          Description is required
        </div>
      </div>

      <div class="form-group mb-4">
        <label for="serviceSelect"
          >Select Service: <span class="text-danger">*</span></label
        >
        <select
          class="form-control"
          id="serviceSelect"
          [(ngModel)]="selectedService"
          name="service"
          (change)="onServiceSelect($event)"
        >
          <option value="">Select a service</option>
          <option *ngFor="let service of ServiceList" [value]="service._id">
            {{ service.serviceName }}
          </option>
        </select>
        <div *ngIf="showServiceError" class="text-danger mt-1">
          Please select at least one service
        </div>
        <div
          *ngIf="selectedServices.length > 0"
          class="mt-2 d-flex align-items-center"
        >
          Selected Services:
          <span
            *ngFor="let service of selectedServices"
            class="badge badge-primary mr-1 p-1 ml-1"
            style="
              font-size: 12px;
              display: flex;
              align-items: center;
              gap: 2;
              width: fit-content;
            "
          >
            {{ IsEdit ? getServiceName(service) : getServiceName(service) }}
            <button
              type="button"
              class="close ml-1"
              (click)="removeService(service)"
              aria-label="Remove"
              style="color: white"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </span>
        </div>
      </div>

      <div class="form-group mb-4">
        <label>Upload Images:</label>
        <input
          #imageInput
          type="file"
          (change)="onImageSelect($event)"
          multiple
          accept="image/*"
          class="d-none"
        />

        <div class="image-upload-container">
          <div class="row">
            <div class="col-md-3 col-sm-4 col-6 mb-3">
              <div
                class="upload-placeholder d-flex align-items-center justify-content-center"
                (click)="imageInput.click()"
                style="
                  height: 150px;
                  border: 1px dashed gray;
                  border-radius: 8px;
                  cursor: pointer;
                  background-color: #f8f9fa;
                "
              >
                <div class="text-center text-muted">
                  <i class="fas fa-plus mb-2" style="font-size: 24px"></i>
                  <p class="mb-0">Add Image</p>
                </div>
              </div>
            </div>

            <div
              class="col-md-3 col-sm-4 col-6 mb-3"
              *ngFor="let image of images; let i = index"
            >
              <div class="preview-container position-relative">
                <img
                  [src]="image.url"
                  class="img-thumbnail w-100"
                  style="height: 150px; object-fit: cover; border-radius: 8px"
                />
                <button
                  type="button"
                  class="btn btn-danger btn-sm position-absolute"
                  style="
                    top: 5px;
                    right: 5px;
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;
                    padding: 0;
                    font-size: 12px;
                  "
                  (click)="removeImage(i)"
                >
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group mb-4">
        <label>Upload Videos:</label>
        <input
          #videoInput
          type="file"
          (change)="onVideoSelect($event)"
          multiple
          accept="video/*"
          class="d-none"
        />

        <div class="video-upload-container">
          <div class="row">
            <div class="col-md-3 col-sm-4 col-6 mb-3">
              <div
                class="upload-placeholder d-flex align-items-center justify-content-center"
                (click)="videoInput.click()"
                style="
                  height: 150px;
                  border: 1px dashed gray;
                  border-radius: 8px;
                  cursor: pointer;
                  background-color: #f8f9fa;
                "
              >
                <div class="text-center text-muted">
                  <i class="fas fa-video mb-2" style="font-size: 24px"></i>
                  <p class="mb-0">Add Video</p>
                </div>
              </div>
            </div>

            <div
              class="col-md-3 col-sm-4 col-6 mb-3"
              *ngFor="let video of videos; let i = index"
            >
              <div class="preview-container position-relative">
                <video
                  [src]="video.url"
                  class="img-thumbnail w-100"
                  style="height: 150px; object-fit: cover; border-radius: 8px"
                  controls
                ></video>
                <button
                  type="button"
                  class="btn btn-danger btn-sm position-absolute"
                  style="
                    top: 5px;
                    right: 5px;
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;
                    padding: 0;
                    font-size: 12px;
                  "
                  (click)="removeVideo(i)"
                >
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group mb-4">
        <label
          >Select Store Location on Map:
          <span class="text-danger">*</span></label
        >
        <div *ngIf="showLocationError" class="text-danger mb-2">
          Please select a location on the map
        </div>
        <small class="form-text text-muted d-block mb-2">
          Click on the map or search for a location to set your store location.
          You can also drag the marker to adjust the position.
        </small>
        <div
          id="storeLocationMap"
          style="width: 100%; height: 300px; border-radius: 10px"
          class="border rounded"
        ></div>
        <div class="mt-2">
          <p>
            <strong>Selected Location:</strong>
            {{ selectedLocation || "None selected" }}
          </p>
          <input type="hidden" [(ngModel)]="lat" name="lat" />
          <input type="hidden" [(ngModel)]="lng" name="lng" />
          <input type="hidden" [(ngModel)]="selectedLocation" name="location" />
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="closeBtnClick()">
        Close
      </button>
      <button type="submit" class="btn btn-primary">
        {{ modeltitle === "Add Location" ? "Add Location" : "Update Location" }}
      </button>
    </div>
  </form>
</ng-template>
<ng-template #deleteModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="deleteModalLabel">Delete Location</h5>
    <button
      type="button"
      class="close"
      (click)="closeBtnClick()"
      aria-label="Close"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">Are you sure you want to delete this location?</div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-secondary"
      (click)="closeDeleteModalClick()"
    >
      Cancel
    </button>
    <button type="button" class="btn btn-danger" (click)="confirmDelete()">
      Delete
    </button>
  </div>
</ng-template>
